import copy from 'fast-copy';
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { serviceResponse } from '../../../services/common';
import { getPositions, Position, togglePositionStatus } from '../../../services/Position';
import { setLocalPositions } from '../../../services/store/common';
import { PowerIcon } from '../../Icons';
import { colors } from '../../Shared';

interface Props {
    position: Position
}

export default function PositionItem({ position }: Props) {
    const dispatch = useDispatch();
    const { name, id, isActive } = position;

    const onPress = async () => {

        const positionCopy = copy(position);
        positionCopy.isActive = !isActive;
        const req = await togglePositionStatus(id, isActive);
        if (req === serviceResponse.systemError || req === serviceResponse.emptyFields) {
            return alert("Something went wrong, please try it again");
        }

        const positions = await getPositions() as Position[];
        dispatch(setLocalPositions(positions));
    }

    return <View style={styles.container}>
        <Text style={{ flex: 1, textTransform: "capitalize" }}>
            {name}
        </Text>

        <Pressable onPress={onPress} style={{ marginRight: 5 }}>
            <PowerIcon color={isActive ? colors.bg.green : colors.bg.yellow} size={18} />
        </Pressable>
    </View>
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        height: 50,
        backgroundColor: colors.bg.light,
        top: 5,
        margin: 5,
        borderRadius: 5,
        alignItems: 'center',
        padding: 5
    }
});